import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, TableSortLabel, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { visuallyHidden } from '@mui/utils';
import MuiAlert from '@mui/material/Alert';
import FeedIcon from '@mui/icons-material/Feed';
import axios from "../../../components/axios";



const StickyHeaErrorQueryTable = ({ rows, columns, handleEdit, handleDelete, title, imageName, item_option, fullQuery }) => {
  const navigate = useNavigate();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [open, setOpen] = React.useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const descendingComparator = React.useCallback((a, b, orderBy) => {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      return 0;
  }, []);

  const getComparator = React.useCallback(() => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
  }, [descendingComparator,order,orderBy]);

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)),
    [rows, getComparator, order, orderBy],
  );

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  };

  const handleCellClick = (event, row) => {
    if (!fullQuery){
      return
    }
    setOpen(true);
    let errID = event.target.id;
    let errorType = "";
    if (errID.includes("ANR")) {
      errorType = "ANR"
    } else {
      errorType = "Kernel"
    }
    handleShareLink(errorType, row.home_app_version);
};

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

const handleShareLink = (errorType, appVersion) => {
    axios.post("/peloton/v1/automation/"+errorType+"_"+appVersion+"/error-share-link",fullQuery,{withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          //navigator.clipboard.writeText(response.data.url)
          window.open(response.data.url, "_blank");
        }else{
          alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
    setOpen(true)
  };

  return (
    <>
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
          <TableRow key="error_name">
              <TableCell align="center" colSpan={1} sx={{ color:"white", bgcolor:"#406599" }} key="error_name">
                Error Name
              </TableCell>
              {item_option.map((column) => (
                <TableCell align="center" colSpan={3} sx={{ color:"white", bgcolor:"#406599", border: 1 }} key={column}>
                {column}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  sortDirection={orderBy === column.id ? order : false}
                  sx={{ minWidth: column.minWidth, color:"white", bgcolor:"#406599" }}
                >
                <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : 'asc'}
                    onClick={createSortHandler(column.id)}
                  >
                    {column.label}
                    {orderBy === column.id ? (
                      <Box component="span" sx={visuallyHidden}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </Box>
                    ) : null}
                </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows
              .map((row) => {
                let uuid = row.uuid;
                if (row.uuid === undefined) {
                  uuid = row.token;
                }
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={uuid}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell id={column.id} key={column.id} align={column.align} onClick={(event) => handleCellClick(event, row)}>
                        {typeof value === 'boolean'?
                          (value === false ? 'False':'True'):
                          (column.action?
                            (<div><Button onClick={() => handleEdit(uuid)}><EditIcon sx={{ color: "#406599",fontSize: 20 }}/></Button><Button onClick={() => handleDelete(uuid)}><DeleteIcon sx={{ color: "#406599", fontSize: 20 }}/></Button></div>):
                            (column.skip?(<div><Button onClick={() => handleEdit(uuid)}><FeedIcon sx={{ color: "#406599",fontSize: 20 }}/></Button><Button onClick={() => handleDelete(uuid)}><DeleteIcon sx={{ color: "#406599", fontSize: 20 }}/></Button></div>):(value)))}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={handleClose} severity="info" sx={{ width: '100%' }}>
          Link copy to clipboard!
        </Alert>
      </Snackbar>
    </Paper>
    </>
  );
}

export default StickyHeaErrorQueryTable;
